import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { withRouter, useParams } from "react-router-dom";
import moment from "moment";
import {
  Document,
  Page,
  StyleSheet,
  PDFDownloadLink,
} from "@react-pdf/renderer";

import { makeStyles } from "@material-ui/core/styles";
import Button from "components/CustomButtons/Button.js";
import BaseView from "layouts/BaseView.js";

import generateTicketHtml from "util/generateTicketHtml.js";

import shippingAddressStyle from "assets/jss/material-dashboard-pro-react/views/shippingAddressStyle.js";

const useStyles = makeStyles(shippingAddressStyle);

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "#ffffff",
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
});

function BaseThankYou(props) {
  const {
    shippingInfo,
    updateCart,
    cart,
    museum,
    history,
    customStyle,
    updateShippingInfo,
    reservations,
    cartUnique,
  } = props;

  const { t } = useTranslation();
  const classes = useStyles();

  const { home } = useParams();

  var url = history.location.pathname;
  url = url.slice(0, url.lastIndexOf("/"));
  url = url.slice(0, url.lastIndexOf("/")) + "/shop/" + home;

  function createPdfVoucher() {
    return (
      <Document>
        {reservations.map((element, i) => {
          let nome = "";
          if (
            element.prenotazione &&
            element.prenotazione.nome_partecipante &&
            element.prenotazione.cognome_partecipante
          ) {
            nome =
              element?.prenotazione?.nome_partecipante +
              " " +
              element?.prenotazione?.cognome_partecipante;
          } else if (
            element.nome_partecipante &&
            element.cognome_partecipante
          ) {
            nome =
              element?.nome_partecipante + " " + element?.cognome_partecipante;
          }
          let oraInizio = element?.prenotazione?.evento?.ora_inizio;
          if (!oraInizio && element.ora_inizio) {
            oraInizio = element.ora_inizio;
          }
          return (
            <Page
              key={i.toString()}
              size="A4"
              style={styles.page}
              pageNumber={i + 1}
            >
              {generateTicketHtml(
                nome,
                museum.nome, // museumName,
                museum.numero_telefono_museo,
                museum.email_museo,
                museum.indirizzo_museo +
                  ", " +
                  museum.citta_museo +
                  " - " +
                  museum.CAP_museo,
                museum.logo_light.url,
                element?.prenotazione?.main_evento?.luogo_evento,
                moment(
                  element?.prenotazione?.giorno_prenotazione ||
                    element?.giorno_prenotazione
                ).format("DD/MM/YYYY"), // date
                oraInizio,
                element?.prenotazione?.evento?.ora_fine,
                element?.prenotazione?.evento?.nome_evento,
                element?.prenotazione?.main_evento?.descrizione_evento ||
                  museum?.descrizione_museo,
                element?.prenotazione?.numero_partecipanti ||
                  element?.numero_partecipanti,
                element?.prenotazione?.articolo?.nome_articolo, // typeTicket
                element?.prenotazione?.articolo?.prezzo_articolo, // price
                element?.prenotazione?.metodo_pagamento,
                element?.prenotazione?.codice || element?.codice // code
              )}
            </Page>
          );
        })}
      </Document>
    );
  }

  return (
    <>
      <BaseView
        buttons={[
          {
            onClick: () => {
              // RESETTA I CAMPI
              updateCart([]);
              // AGGIUNGI RESET CREDENZIALI
              updateShippingInfo({
                // CONTACT
                firstName: "",
                lastName: "",
                email: "",
                prefix: "+39",
                telephone: "",
                date: shippingInfo.date,
              });
              // window.location.href = {url};
              history.replace(url);
              window.location.reload(true);
            },
            color: "whiteRed",
            text: t("shippingAddress.back_menu"),
            isActive: !(cartUnique?.length === 0 || cart?.length === 0),
            path: `../shop`,
            classNameText: classes.buttonBigTextMenu,
            customColor: customStyle.buttonAction,
            buttonStyle: customStyle.buttonBackToMenu,
          },
        ]}
        // backLinks={history.replace(url)}
        title={t("confirmedReservation")}
      >
        <>
          {cartUnique &&
            cartUnique.length > 0 &&
            cartUnique.map((element, i) => {
              const price = (
                element.data?.length * element.data[0]?.price
              ).toFixed(2);
              return (
                <div key={`${element.nome_articolo}_${i.toString()}`}>
                  <div
                    style={{
                      display: "flex",
                      paddingLeft: "10px",
                      flexDirection: "row",
                    }}
                  >
                    <div style={{ display: "flex", flex: 1 }}>
                      {element.data?.length}x {element.data[0]?.item?.nome}
                    </div>
                    <div>{price}€</div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      flex: 1,
                    }}
                  >
                    {element.data.map((cont, ind) => {
                      return (
                        <div
                          key={ind.toString()}
                          style={{ padding: "5px 5px 10px 20px" }}
                        >
                          <span>
                            {cont?.visitatore?.nome} {cont?.visitatore?.cognome}
                          </span>
                        </div>
                      );
                    })}
                    <div
                      style={
                        i !== element.data.length - 1
                          ? {
                              width: "100%",
                              margin: "0 auto",
                              height: 1,
                              backgroundColor: "rgba(240,240,240,1)",
                            }
                          : null
                      }
                    ></div>
                  </div>
                </div>
              );
            })}
          <div style={{ display: "flex", justifyContent: "center" }}>
            <PDFDownloadLink
              document={createPdfVoucher()}
              fileName={
                "Prenotazione " +
                museum.nome +
                " " +
                moment(
                  reservations[0]?.prenotazione?.giorno_prenotazione
                ).format("DD-MM-YYYY") +
                ".pdf"
              }
            >
              {/* eslint-disable-next-line */}
              {({ blob, url, loading, error }) => {
                return loading ? (
                  <p style={{ color: "#303030" }}>Caricamento documento...</p>
                ) : (
                  <Button
                    style={{
                      backgroundColor: "#303030",
                    }}
                  >
                    Scarica biglietti
                  </Button>
                );
              }}
            </PDFDownloadLink>
          </div>
        </>
      </BaseView>
    </>
  );
}

BaseThankYou.propTypes = {
  currency: PropTypes.shape({
    name: PropTypes.string,
    rate: PropTypes.number,
    symbol: PropTypes.string,
  }).isRequired,
  updateCart: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  cart: PropTypes.arrayOf(PropTypes.object),
  reservations: PropTypes.arrayOf(PropTypes.object),
  cartUnique: PropTypes.any,
  updateCartUnique: PropTypes.func.isRequired,
  history: PropTypes.any,
  museum: PropTypes.object,
  customStyle: PropTypes.object,
  shippingInfo: PropTypes.shape({
    date: PropTypes.any,
  }).isRequired,
  updateShippingInfo: PropTypes.func.isRequired,
};

BaseThankYou.defaultProps = {
  museum: null,
  customStyle: {},
  cartUnique: {},
  cart: [],
  history: null,
};

export default withRouter(BaseThankYou);
